export const REGISTRATION_LINKS_FORM_ID = 'REGISTRATION_LINKS_FORM_ID';
